import * as React from 'react';

import { TextInputDecorator } from '../components/TextInputDecorator/TextInputDecorator';

import { DictionaryItem } from './common';

export type TagValue = string | string[];

export enum TargetingTagType {
    INCLUDED = 'included',
    EXCLUDED = 'excluded'
}

export enum TagState {
    LOADING = 'loading',
    VALID = 'valid',
    INVALID = 'invalid',
    UNSET = 'unset'
}

export interface ExtendedTagValue {
    value: TagValue;
    renderValue?: TagValue;
    tagState: TagState;
}

export interface TargetingTagValue extends ExtendedTagValue {
    type: TargetingTagType;
}

export interface TargetingCloudProps {
    tags: TargetingTagValue[];
    onAdd?: (tags: TargetingTagValue[]) => void;
    onDelete: (tag: TargetingTagValue) => void;
    onChange?: (tag: TargetingTagValue, newValue: TagValue) => void;
    dictionaryItems?: DictionaryItem[];
    showUserValueOnEdit?: boolean;
    type?: TagInputType;
}

export interface TargetingToggle {
    id: string;
    title: string;
}

export interface TagCloudTargeting {
    tags: TargetingTagValue[];
    isEditorOpen: boolean;
    savedValue?: Pick<TagCloudTargeting, 'tags'>;
}

export type TagCloudTargetingsState = Record<string, TagCloudTargeting>;

export enum TagInputType {
    INPUT = 'input',
    SUGGEST = 'suggest',
    SUGGEST_WITH_VERSION = 'suggestWithVersion',
    TOGGLE = 'toggle'
}

export interface TagEditorProps {
    tagValue?: TagValue;
    inputType?: TagInputType;
    index: number;
    onSubmit: (value: TagValue[], isTriggeredByBlur?: boolean) => void;
    onFocus?: () => void;
    onBlur?: () => void;
    onDelete?: (index: number) => void;
    onCancel: (isTriggeredByBlur?: boolean) => void;
    onRefChange?: (ref: React.RefObject<TextInputDecorator>) => void;
    onPaste?: (value: TagValue[]) => void;
    onKeyDown?: (evt: React.KeyboardEvent<HTMLInputElement>) => void;
    suggestItems?: DictionaryItem[];
}
